import axios from "axios";
export var fetchBitacoraVersions = function fetchBitacoraVersions(poliza_id) {
  return axios.get("/api/v1/polizas/".concat(poliza_id, "/bitacora_versions"), {
    timeout: 5000
  }).then(function (response) {
    return response.data;
  })["catch"](function (error) {
    if (error.code === 'ECONNABORTED' || error.response && error.response.status === 500) {
      return {
        versions: []
      };
    }

    throw error;
  });
};
export var getVersionsQueryKey = function getVersionsQueryKey(poliza_id) {
  return ["/api/v1/polizas/".concat(poliza_id, "/bitacora_versions")];
};